export function getLoginMissLocation() {
  const location = localStorage.getItem('TD-loginMissRedirect')
  if (location === '/' || location === '') {
    return '/turboscript'
  }
  return location
}
